import React, { ChangeEvent } from 'react';
import { formatDocument } from 'utils/Document';
import Text from 'components/Text';
import { Row, Column } from 'components/Layout/Grid';
import { CustomerDataProps } from './interface';
import { InputDocument, InputCustomer } from './styles';

export const CustomerData: React.FC<CustomerDataProps> = (props) => {
  const {
    documentNumber,
    setDocumentNumber,
    customerName,
    setCustomerName,
    isEditing
  } = props;

  return (
    <Row className="flex-md-column">
      <Column className="mt-md-2">
        <Text className="mb-2 flex-md-100 color-blue-gray" size={12}>
          CPF/CNPJ
        </Text>
        <InputDocument
          value={formatDocument(documentNumber)}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setDocumentNumber(e.target.value)}
          disabled={isEditing}
        />
      </Column>
      <Column className="ml-4 ml-sm-0 mt-md-2">
        <Text className="mb-2 flex-md-100 color-blue-gray" size={12}>
          Cliente
        </Text>
        <InputCustomer
          value={customerName}
          onChange={(e: ChangeEvent<HTMLInputElement>) => setCustomerName(e.target.value)}
          disabled={isEditing}
        />
      </Column>
    </Row>
  );
};